export default {
  tab: {
    selectJob: 'Chargenauswahl',
  },
};
